import { render } from "./ModalLogProduto.vue?vue&type=template&id=cd8d75a6&ts=true"
import script from "./ModalLogProduto.vue?vue&type=script&lang=ts"
export * from "./ModalLogProduto.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__